import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import MainLayout from "./layouts/MainLayout";
import Playground from "pages/playground";
import PlaygroundLayout from "layouts/Playground";
import Setup from "pages/setup";
import Load from "pages/load";

import Login from "pages/auth/login";
import Register from "pages/auth/register";
import Logout from "pages/auth/logout";
import ForgotPassword from "pages/auth/forgot-password";
import ResetPassword from "pages/auth/reset-password";
import ChangePassword from "pages/auth/change-password";
import LoadLayout from "layouts/LoadLayout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route index element={<Home />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/setup" element={<Setup />} />
        </Route>

        <Route element={<LoadLayout />}>
          <Route path="/load" element={<Load />} />
        </Route>

        <Route path="/playground" element={<PlaygroundLayout />}>
          <Route index element={<Playground />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
